import { render } from "./QuestProgressBlock.vue?vue&type=template&id=49b64395&scoped=true"
import script from "./QuestProgressBlock.vue?vue&type=script&lang=js"
export * from "./QuestProgressBlock.vue?vue&type=script&lang=js"

import "./QuestProgressBlock.vue?vue&type=style&index=0&id=49b64395&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b64395"]])

export default __exports__